import { isPlatformBrowser } from '@angular/common';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class KbCaptchaService {

  private challengeExpirySubject = new BehaviorSubject<string>('');
  challengeExpiry$ = this.challengeExpirySubject.asObservable();

  private imageUrlSubject = new BehaviorSubject<string>('');
  imageUrl$ = this.imageUrlSubject.asObservable();

  private responseSubject = new BehaviorSubject<string>('');
  response$ = this.responseSubject.asObservable();
  @Inject(PLATFORM_ID) private platformId: Object
  constructor(private http: HttpClient, private occService: OccEndpointsService,

  ) { }


  fetchCaptcha() {

    if (!isPlatformBrowser(this.platformId)) {
      // On SSR, do nothing or set a placeholder
      this.challengeExpirySubject.next(null);
      this.imageUrlSubject.next(null);
      return;
    }

    this.http.get('https://api.knorr-bremse.com/captcha/image-captcha/challenge/image', { observe: 'response', responseType: 'blob' })
      .subscribe(response => {
        const imageUrl = URL.createObjectURL(response.body);
        const challengeExpiry = response.headers.get('challenge-expiry');
        this.challengeExpirySubject.next(challengeExpiry);
        this.imageUrlSubject.next(imageUrl);
      }
        , err => {
          // handle error gracefully
          this.challengeExpirySubject.next(null);
          this.imageUrlSubject.next(null);
        }
      );
  }

  submitCaptcha(challengeExpiry: string, captchaInput: string): Observable<HttpResponse<string>> {
    const apiUrl = `https://api.knorr-bremse.com/captcha/Captcha/challenge/${challengeExpiry}/jwt?solution=${captchaInput}`;
    return this.http.get(apiUrl, { observe: 'response', responseType: 'text' });

  }

}
